import React from "react";
import Images from "../../../assets/images/index";
import { useNavigate } from "react-router-dom";

export default function Pending (){ 
    let navigate = useNavigate()
    const goHome = ()=>{
        navigate('/package/Basic');
    }
    return(
        <div className="success_wrapper text-center">
            <figure>
                <img src={Images.Pending} alt="" className="img-fluid"/>
            </figure>
            <div className="success_content">
                <h6>Transaction Pending</h6>
                <p>Your transaction status is not updated yet. If money is deducted from your bank then please don't initiate a transaction again. We will update you as soon as we receive status of your transaction</p>
                <div className="sucess_btn">
                    <button type="button" className="btn btn_success" onClick={()=>goHome()}>Go Back</button>
                </div>
            </div>
        </div>
    )
}